import Vue from 'vue';

const NavigationBus = new Vue();

export default NavigationBus;



// WEBPACK FOOTER //
// ./src/event-bus/navigation-bus.js